import { TextureLoader } from "three"

const loader = new TextureLoader()

export default function loadTextures(images)
{
    return Promise.all(
        images.map(img => loader.loadAsync(img))
    )
    .catch(e => console.error("Error loading textures" + e))
}
